import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

const Register = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [name, setName] = useState("");
    const [gender, setGender] = useState("");
    const [parentName, setParentName] = useState("");
    const [dob, setDob] = useState("");
    const [qualification, setQualification] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleRegister = async () => {
        if (
            !name ||
            !gender ||
            !parentName ||
            !dob ||
            !qualification ||
            !mobile ||
            !email ||
            !password
        ) {
            alert("Please fill all fields.");
            return;
        }

        if (password.length < 6) {
            alert("Password must be at least 6 characters.");
            return;
        }

        try {
            setLoading(true);

            const userCredential =
                await createUserWithEmailAndPassword(
                    auth,
                    email,
                    password
                );

            await setDoc(doc(db, "user", mobile), {
                uid: userCredential.user.uid,
                name,
                gender,
                parentName,
                dob,
                qualification,
                mobile,
                password,
                email,
                createdAt: serverTimestamp(),
                admin: false
            });

            localStorage.setItem("mobile", mobile);

            alert("Registration Successful!");

            navigate("/dashboard");
        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: "100vh",
                background:
                    "linear-gradient(to bottom right,#f9fafb,#f3f4f6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "30px 20px",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "500px",
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "35px",
                    boxShadow:
                        "0 10px 25px rgba(0,0,0,0.08)",
                }}
            >
                <h1
                    style={{
                        textAlign: "center",
                        color: "#111827",
                        marginBottom: "8px",
                        fontSize: "2rem",
                        fontWeight: "700",
                    }}
                >
                    Create Account
                </h1>

                <p
                    style={{
                        textAlign: "center",
                        color: "#6b7280",
                        marginBottom: "30px",
                    }}
                >
                    Start your learning journey 🚀
                </p>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Full Name
                    </label>

                    <input
                        type="text"
                        placeholder="Enter your full name"
                        value={name}
                        onChange={(e) =>
                            setName(e.target.value)
                        }
                        style={inputStyle}
                    />
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Gender
                    </label>

                    <select
                        value={gender}
                        onChange={(e) =>
                            setGender(e.target.value)
                        }
                        style={inputStyle}
                    >
                        <option value="">
                            Select Gender
                        </option>
                        <option value="Male">
                            Male
                        </option>
                        <option value="Female">
                            Female
                        </option>
                        <option value="Other">
                            Other
                        </option>
                    </select>
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Father's / Mother's Name
                    </label>

                    <input
                        type="text"
                        placeholder="Enter parent's name"
                        value={parentName}
                        onChange={(e) =>
                            setParentName(e.target.value)
                        }
                        style={inputStyle}
                    />
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Date of Birth
                    </label>

                    <input
                        type="date"
                        value={dob}
                        onChange={(e) =>
                            setDob(e.target.value)
                        }
                        style={inputStyle}
                    />
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Educational Qualification
                    </label>

                    <select
                        value={qualification}
                        onChange={(e) =>
                            setQualification(
                                e.target.value
                            )
                        }
                        style={inputStyle}
                    >
                        <option value="">
                            Select Qualification
                        </option>
                        <option>
                            Class X
                        </option>
                        <option>
                            Class XII
                        </option>
                        <option>
                            Diploma
                        </option>
                        <option>
                            Bachelor Degree
                        </option>
                        <option>
                            Master Degree & Above
                        </option>
                    </select>
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Mobile Number
                    </label>

                    <input
                        type="tel"
                        placeholder="98XXXXXXXX"
                        value={mobile}
                        onChange={(e) =>
                            setMobile(e.target.value)
                        }
                        style={inputStyle}
                    />
                </div>

                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>
                        Email Address
                    </label>

                    <input
                        type="email"
                        placeholder="abc@email.com"
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                        style={inputStyle}
                    />
                </div>

                <div style={{ marginBottom: 30 }}>
                    <label style={labelStyle}>
                        Password
                    </label>

                    <input
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) =>
                            setPassword(
                                e.target.value
                            )
                        }
                        style={inputStyle}
                    />
                </div>
                                <button
                    onClick={handleRegister}
                    disabled={loading}
                    style={{
                        width: "100%",
                        background: "#3b82f6",
                        color: "#fff",
                        border: "none",
                        borderRadius: "14px",
                        padding: "15px",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: loading ? "not-allowed" : "pointer",
                        opacity: loading ? 0.7 : 1,
                        transition: "0.3s",
                    }}
                >
                    {loading
                        ? "Creating Account..."
                        : "Register"}
                </button>

                <div
                    style={{
                        marginTop: "25px",
                        textAlign: "center",
                        color: "#6b7280",
                        fontSize: "0.95rem",
                    }}
                >
                    Already have an account?

                    <span
                        onClick={() =>
                            navigate("/")
                        }
                        style={{
                            marginLeft: "6px",
                            color: "#3b82f6",
                            cursor: "pointer",
                            fontWeight: "600",
                        }}
                    >
                        Login
                    </span>
                </div>
            </div>
        </div>
    );
};

const labelStyle = {
    display: "block",
    marginBottom: "8px",
    color: "#374151",
    fontWeight: "600",
    fontSize: "0.95rem",
};

const inputStyle = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "12px",
    border: "1px solid #d1d5db",
    outline: "none",
    fontSize: "1rem",
    boxSizing: "border-box",
    background: "#fff",
    transition: "0.3s",
};

export default Register;